import { AbstractPmsApiService } from "./abstract.service";
import { ChannelManagerTariffSettings } from "../models";

/**
 * @abstract
 * @extends {AbstractPmsApiService<ChannelManagerTariffSettings>}
 */
export class ChannelManagerTariffSettingsService extends AbstractPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/channel-manager-tariff-settings';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {ChannelManagerTariffSettings}
     * @protected
     */
    newModel(attributes, ...params) {

        return new ChannelManagerTariffSettings(attributes);
    }

    /**
     * @returns {Promise.<ChannelManagerTariffSettings>}
     */
    get() {

        return this.http
            .get(this.url(), {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {ChannelManagerTariffSettings} model
     * @returns {Promise.<ChannelManagerTariffSettings>}
     */
    save(model) {

        return this.http
            .post(this.url(), model, {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/channel-manager-tariff-setting.service.js